// Generated from src/img/svg/ic-db_navigation_expand-less_24.svg

export const IcDbNavigationExpandLess24 = (props) => {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" {...props}>
      <path
        d="M18 16c.563 0 1-.437 1-1 0-.25-.125-.5-.312-.687l-5.97-6.032A1.04 1.04 0 0 0 12 8c-.25 0-.531.094-.719.281l-5.969 6.031C5.126 14.5 5 14.75 5 15c0 .563.438 1 1 1 .281 0 .5-.094.719-.281L12 10.438l5.281 5.28A1 1 0 0 0 18 16"
        fill="#282D37"
        fillRule="evenodd"
      />
    </svg>
  );
};
